module.exports = __webpack_public_path__ + "static/media/CARROT.b4fe4ccd.png";